import { useAccount } from './useAccount'
import { MeetingLanguage } from '../models/Room'

export const useMultiLanguageEnabled = () => {
  const { account } = useAccount({ refetchOnMountOrArgChange: false })
  const multiLanguageEnabled = account?.effectiveConfig.multiLanguageSupport?.enabled ?? false
  const defaultLanguage = account?.effectiveConfig.multiLanguageSupport?.defaultLanguage ?? MeetingLanguage.ENGLISH
  return { multiLanguageEnabled, defaultLanguage }
}
